import { Directive, computed, inject, input } from '@angular/core';

import { RecentlyCreatedRegistry } from './recently-created.registry';

/** Keyframes that finish last; used to detect the end of the whole effect. */
const FLASH_ANIMATION_NAME = 'ocp-highlight-insert-flash';

/**
 * Plays a short "just created by me" entrance + colour-highlight animation on the host element
 */
@Directive({
  selector: '[ocpHighlightInsertRow]',
  host: {
    '[class.ocp-highlight-insert]': 'isHighlighted()',
    '(animationend)': 'onAnimationEnd($event)',
  },
})
export class HighlightInsertRowDirective {
  private readonly recentlyCreated = inject(RecentlyCreatedRegistry);

  /** Entity id looked up in the registry, or a plain boolean trigger. */
  readonly ocpHighlightInsertRow = input<string | boolean | null | undefined>(false);

  protected readonly isHighlighted = computed(() => {
    const trigger = this.ocpHighlightInsertRow();
    return typeof trigger === 'string' ? this.recentlyCreated.isRecent(trigger) : trigger === true;
  });

  protected onAnimationEnd(event: AnimationEvent): void {
    const trigger = this.ocpHighlightInsertRow();
    if (event.animationName === FLASH_ANIMATION_NAME && typeof trigger === 'string') {
      this.recentlyCreated.clear(trigger);
    }
  }
}
